import { NextPage, NextPageContext } from 'next';
import React from 'react';
import { SSRPageProps, SSRPageProvider } from '../components/SSRPage/SSRPage';
import { Home } from '../page-components/home-page';

const Page: NextPage<any> = (props) => <SSRPageProvider props={props} SSRComp={Home} />;

Page.getInitialProps = (context: NextPageContext) => SSRPageProps(Home, context);

export default Page;
